module.exports = __webpack_public_path__ + "static/media/jumbotron__image--5.9c41c6c8.jpg";